import { Injectable } from '@angular/core';
import { AmplifyService } from 'app/aws/amplify.service';

@Injectable({
  providedIn: 'root'
})
export class FetchMessageService {
  constructor(private readonly amplifyService: AmplifyService) {}

  /**
   * Get status for a specific Jira resync process
   * @param {string} uuid The unique identifier for the resync process
   * @returns {Promise<any>} A promise resolving to the status response
   */
  async getStatus(uuid: string): Promise<any> {
    const config = {
      queryParams: {
        uuid: uuid
      }
    };

    try {
      const response = await this.amplifyService.callAPI(
        'post',
        'gsoAPI',
        '/jira-resync-ms-status',
        config
      );
      return response;
    } catch (error) {
      console.error('Failed to fetch resync status:', error);
      throw error;
    }
  }
}
